'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const BaseTileTargetImage = renderWithRef('BaseTileTargetImage', null, (r, t)=>jsx(RenderComp, {
        root: "a",
        forwardedRef: t,
        classNames: [
            'swan-base-tile-target-image',
            'swan-button-skin-unstyled'
        ],
        props: r,
        children: r.children
    }));

export { BaseTileTargetImage };
